import React from 'react';

import './styles.scss';
import ListLanguages from '../../components/ListLanguages';
import Loading from '../../components/Loading';

interface WrapperProps {
    loading?: boolean;
    children: React.ReactNode;
    backgroundImage?: string;
    logo?: string;
    message?: string;
}

const Wrapper: React.FC<WrapperProps> = ({ loading = true, children, backgroundImage, logo, message = '' }) => {
    const LOADING_STYLES = {
        backgroundImage: `url("${backgroundImage}")`,
    };

    return loading ? (
        <Loading backgroundImage={backgroundImage} message={message} />
    ) : (
        <div className="flexContainer" style={LOADING_STYLES}>
            <header>
                {logo && <img className="flexContainerLogo" src={logo} alt="Logo" />}
                <div className="languagesContainer">
                    <ListLanguages />
                </div>
            </header>
            {children}
            <div className="AppPrivacyPolicy">
                <a
                    href="https://www.goodtime.io/privacy-policy"
                    className="policyLink"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Privacy Policy
                </a>
            </div>
        </div>
    );
};

export default Wrapper;
